/**
 * Main application script - handles UI interactions and MathJax rendering
 */ /**
 * Main equation generation service
 * Coordinates generator functions to create complex mathematical expressions
 */ /**
 * LaTeX expression generators for various mathematical concepts
 */ /**
 * Mathematical utility functions
 */ /**
 * Check if a number is odd
 * @param {number} n - The number to check
 * @returns {boolean} True if odd, false otherwise
 */ function $1dbc6a46e06e42e9$export$d36793d8f5c37d4d(n) {
    return n % 2 !== 0;
}
function $1dbc6a46e06e42e9$export$18e26528b2f5558d(n) {
    return Number.isInteger(Math.sqrt(n));
}
function $1dbc6a46e06e42e9$export$8676dd5fabd5ee34(n) {
    if (n <= 1) return false;
    if (n % 2 === 0 && n > 2) return false;
    const s = Math.sqrt(n);
    for(let i = 3; i <= s; i += 2){
        if (n % i === 0) return false;
    }
    return true;
}
function $1dbc6a46e06e42e9$export$b1e4fcbe386851e2(n) {
    const num = Math.abs(parseInt(n));
    if (isNaN(num) || num === 0) return [
        1
    ];
    const factors = [
        ...Array(num + 1).keys()
    ].filter((i)=>i !== 0 && num % i === 0);
    return factors.length > 0 ? factors : [
        1
    ];
}
function $1dbc6a46e06e42e9$export$72ec13a031cbb00(n) {
    const factorialMap = {
        1: 1,
        2: 2,
        6: 3,
        24: 4,
        120: 5,
        720: 6
    };
    return factorialMap[n] || false;
}
function $1dbc6a46e06e42e9$export$3c5f89dae98e900b(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function $1dbc6a46e06e42e9$export$94951fac5549ef77(arr) {
    if (!arr || arr.length === 0) return null;
    return arr[Math.floor(Math.random() * arr.length)];
}


/**
 * Application constants
 */ const $315dbc24fdcb29cb$export$835c3c836997ddb7 = {
    MIN: 0,
    MAX: 1000
};
const $315dbc24fdcb29cb$export$139062143e06098c = 5;
const $315dbc24fdcb29cb$export$b4b8427d5e70889b = 10;
const $315dbc24fdcb29cb$export$e4a566eeb613cc47 = 30;
const $315dbc24fdcb29cb$export$e7301bb713e9013b = 70;
const $315dbc24fdcb29cb$export$32b910926cdc0d75 = 10;
const $315dbc24fdcb29cb$export$cf3c1cc3171a5e4e = 100;
const $315dbc24fdcb29cb$export$6c4c91602b188824 = [
    '-',
    '+'
];


function $32d147077145fdbe$export$329ce89a99f0e343(n, useGammaFunction) {
    if (Math.random() < 0.5 && useGammaFunction) return `{\\Gamma (${n + 1})}`;
    return `{\\prod_{k=1}^{${n}} k}`;
}
function $32d147077145fdbe$export$b79f25742e3e8973(n, useGammaFunction) {
    const fac = (0, $1dbc6a46e06e42e9$export$72ec13a031cbb00)(n);
    if (fac && Math.random() < 0.5) return $32d147077145fdbe$export$329ce89a99f0e343(fac, useGammaFunction);
    const r = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(1, 10);
    if (Math.random() < 0.5) return `{\\lim_{x \\to ${n - r}} {{x^2 - ${r ** 2}} \\over {x - ${r}}}}`;
    return `{\\lim_{x \\to ${n + r}} {{x^2 - ${r ** 2}} \\over {x + ${r}}}}`;
}
function $32d147077145fdbe$export$1923b1715a1d3b35(n) {
    if (n === 0) return `{\\lim_{x \\to \\infty}{ \\ln(x) \\over {x} }}`;
    if (n === 1) return `{\\lim_{x \\to 1}  { {\\ln(x)} \\over {x - 1} }}`;
    return `{\\lim_{x \\to 0}{ {-\\ln(1 + ${n}(e^{-x} - 1))} \\over {x} }}`;
}
function $32d147077145fdbe$export$63b8956c35915643(n) {
    if (n === 0) return `{\\lim_{x \\to \\infty}{xe^{-x}}}`;
    if (n === 1) return `{\\lim_{x \\to 0}{ {e^x - 1} \\over {x} }}`;
    return `{\\lim_{x \\to 0}{ {e^{${n}x} - 1} \\over {x} }}`;
}
function $32d147077145fdbe$export$55706094e203377f(n, useGammaFunction) {
    const fac = (0, $1dbc6a46e06e42e9$export$72ec13a031cbb00)(n);
    if (fac && Math.random() < 0.5) return $32d147077145fdbe$export$329ce89a99f0e343(fac, useGammaFunction);
    if (n === 0) {
        const r = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(0, 19);
        return `{\\lim_{x \\to \\infty}{${r}x^{-1}}}`;
    }
    if (n === 1) return `{\\lim_{x \\to \\infty}{x^{1/x}}}`;
    const m = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(1, 5);
    const highestPower = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(2, 4);
    const numeratorLength = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(1, highestPower - 1);
    const denominatorLength = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(1, highestPower - 1);
    let numerator = `${m * n}x^{${highestPower}} `;
    let denominator = `${m}x^{${highestPower}} `;
    for(let i = numeratorLength; i > 0; i--){
        const coef = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(2, 11);
        const power = i < 2 ? '' : `^{${i}}`;
        numerator += `${(0, $315dbc24fdcb29cb$export$6c4c91602b188824)[Math.floor(Math.random() * 2)]} ${coef}x${power} `;
    }
    for(let i = denominatorLength; i > 0; i--){
        const coef = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(2, 11);
        const power = i < 2 ? '' : `^{${i}}`;
        denominator += `${(0, $315dbc24fdcb29cb$export$6c4c91602b188824)[Math.floor(Math.random() * 2)]} ${coef}x${power} `;
    }
    return `{\\lim_{x \\to \\infty}{{ ${numerator} } \\over {{ ${denominator} }}}}`;
}
function $32d147077145fdbe$export$4f7fcae0ef12d1a7(n, useGammaFunction) {
    const fac = (0, $1dbc6a46e06e42e9$export$72ec13a031cbb00)(n);
    if (fac && Math.random() < 0.5) return $32d147077145fdbe$export$329ce89a99f0e343(fac, useGammaFunction);
    if (n !== 0) return `{-${n}e^{\\pi i}}`;
    return `{(e^{\\pi i} + 1)}`;
}
function $32d147077145fdbe$export$ee3ee67983452ed6(n, useGammaFunction) {
    const fac = (0, $1dbc6a46e06e42e9$export$72ec13a031cbb00)(n);
    if (fac && Math.random() < 0.5) return $32d147077145fdbe$export$329ce89a99f0e343(fac, useGammaFunction);
    if (n === 0) {
        const r = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(3, 12);
        return `{\\sum\\limits_{k=0}^{${r - 1}} {\\sin \\left({ {2 \\pi k} \\over {${r}} } \\right)}}`;
    }
    if (n === 1) return `{\\lim_{\\epsilon \\to 0}{ \\epsilon \\zeta(1 + \\epsilon) }}`;
    return `{\\sum\\limits_{k=0}^\\infty {\\left({${n - 1} \\over {${n}}}\\right)^{k}}}`;
}
function $32d147077145fdbe$export$9a51c259a21d4029(n, randOption) {
    const a = Math.floor(Math.random() * 51) - 10; // Random number from -10 to 40
    if (n > 0) {
        const randomValue = Math.random();
        if (randomValue < 0.25) return `\\left({${randOption(n)} \\over {\\lim_{{x\\to ${a}}}(\\cos^2x + \\sin^2x)}}\\right)`;
        if (randomValue < 0.5) return `\\left({${randOption(n)} \\times \\lim_{{x\\to ${a}}}(\\cos^2x + \\sin^2x)}\\right)`;
        return `\\left({${randOption(n + 1)} - \\lim_{{x\\to ${a}}}(\\cos^2x + \\sin^2x)}\\right)`;
    }
    return `\\left({${randOption(n + 1)} - \\lim_{{x\\to ${a}}}(\\cos^2x + \\sin^2x)}\\right)`;
}


/**
 * Number decomposition strategies for generating complex expressions
 */ 

/**
 * Decompose a number using exponential representation
 * @param {number} n - Target number
 * @param {Function} randomOption1 - First random generator
 * @param {Function} randomOption2 - Second random generator
 * @returns {string} LaTeX string
 */ function $4a118e3e819b7e0c$var$decompose2(n, randomOption1, randomOption2) {
    if (isNaN(n) || n === Infinity) n = 1;
    const randNum = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(6, 8);
    const logValue = Math.log(n) / Math.log(randNum);
    const floorLog = isFinite(logValue) ? Math.floor(logValue) : 0;
    const ceilLog = isFinite(logValue) ? Math.ceil(logValue) : 0;
    const exp1 = randNum ** floorLog;
    const exp2 = randNum ** ceilLog;
    const diff1 = Math.abs(n - exp1);
    const diff2 = Math.abs(n - exp2);
    if (diff1 < diff2) {
        const power = floorLog === 1 ? '' : `^{${floorLog}}`;
        return `{ \\left({${randomOption1(randNum)}}\\right)${power} + {${randomOption2(diff1)}}}`;
    }
    const power = ceilLog === 1 ? '' : `^{${ceilLog}}`;
    return `{ \\left({${randomOption1(randNum)}}\\right)${power} - {${randomOption2(diff2)}}}`;
}
/**
 * Find minimal exponential representation for large numbers
 * @param {number} n - Target number
 * @param {Function} randomOption3 - Random generator function
 * @returns {string} LaTeX string
 */ function $4a118e3e819b7e0c$var$minExp(n, randomOption3, decompose2Fn) {
    let oldDiff, newDiff, exp, exponent;
    const valObj = {};
    // Start with base 3
    let logValue = Math.log(n) / Math.log(3);
    let floorLog = Math.floor(logValue);
    let ceilLog = Math.ceil(logValue);
    let exp1 = 3 ** floorLog;
    let exp2 = 3 ** ceilLog;
    let diff1 = Math.abs(n - exp1);
    let diff2 = Math.abs(n - exp2);
    if (diff1 < diff2) {
        oldDiff = diff1;
        exp = [
            exp1,
            `\\left({${randomOption3(3)}}\\right)^{${floorLog}}`
        ];
        valObj[oldDiff] = exp;
    } else {
        oldDiff = diff2;
        exp = [
            exp2,
            `\\left({${randomOption3(3)}}\\right)^{${ceilLog}}`
        ];
        valObj[oldDiff] = exp;
    }
    // Try bases 4-8
    for(let i = 4; i < 9; i++){
        logValue = Math.log(n) / Math.log(i);
        floorLog = Math.floor(logValue);
        ceilLog = Math.ceil(logValue);
        exp1 = i ** floorLog;
        exp2 = i ** ceilLog;
        diff1 = Math.abs(n - exp1);
        diff2 = Math.abs(n - exp2);
        if (diff1 < diff2) {
            exp = [
                exp1,
                `\\left({${randomOption3(i)}}\\right)^{${floorLog}}`
            ];
            newDiff = diff1;
            valObj[newDiff] = exp;
        } else {
            exp = [
                exp2,
                `\\left({${randomOption3(i)}}\\right)^{${ceilLog}}`
            ];
            newDiff = diff2;
            valObj[newDiff] = exp;
        }
        newDiff = Math.min(newDiff, oldDiff);
        oldDiff = newDiff;
        exponent = valObj[newDiff] || [
            0,
            '0'
        ];
    }
    if (exponent[0] < n) return `${exponent[1]} + \\left({${decompose2Fn(newDiff)}}\\right)`;
    return `${exponent[1]} - \\left({${decompose2Fn(newDiff)}}\\right)`;
}
function $4a118e3e819b7e0c$export$4e06b4a690896b27(n, possibleOptions, sameNumber) {
    // Select random generator functions
    function moreRandomOptions(num) {
        if (isNaN(num)) num = 0;
        if (possibleOptions.length === 0) return sameNumber(num);
        const chosen = (0, $1dbc6a46e06e42e9$export$94951fac5549ef77)(possibleOptions);
        return chosen ? chosen(num) : sameNumber(num);
    }
    let randomOption1 = moreRandomOptions;
    let randomOption2 = moreRandomOptions;
    let randomOption3 = moreRandomOptions;
    if (possibleOptions.length < 1) {
        randomOption1 = sameNumber;
        randomOption2 = sameNumber;
        randomOption3 = sameNumber;
    } else if (possibleOptions.length >= 3) {
        // Select three different options
        const options1 = [
            ...possibleOptions
        ];
        const randIndex1 = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(0, options1.length - 1);
        randomOption1 = options1[randIndex1] || moreRandomOptions;
        const options2 = [
            ...options1
        ];
        options2.splice(randIndex1, 1);
        const randIndex2 = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(0, options2.length - 1);
        randomOption2 = options2[randIndex2] || moreRandomOptions;
        const options3 = [
            ...options2
        ];
        options3.splice(randIndex2, 1);
        const randIndex3 = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(0, options3.length - 1);
        randomOption3 = options3[randIndex3] || moreRandomOptions;
    }
    // Wrapper for decompose2 with bound functions
    const decompose2Fn = (num)=>$4a118e3e819b7e0c$var$decompose2(num, randomOption1, randomOption2);
    // Handle large numbers with exponential representation
    if (n > (0, $315dbc24fdcb29cb$export$e7301bb713e9013b)) return $4a118e3e819b7e0c$var$minExp(n, randomOption3, decompose2Fn);
    const randomValue = Math.random();
    // Strategy 1: Factor decomposition - ab = (a - c)(b + c) + c(b - a + c)
    if (parseInt(n) !== 0 && n < (0, $315dbc24fdcb29cb$export$cf3c1cc3171a5e4e) && (n === 2 || !(0, $1dbc6a46e06e42e9$export$8676dd5fabd5ee34)(n)) && randomValue < 0.25) {
        const factors = (0, $1dbc6a46e06e42e9$export$b1e4fcbe386851e2)(parseInt(n));
        const randomIndex = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(0, factors.length - 1);
        const a = factors[randomIndex] || 1;
        const b = n / a;
        const c = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(1, (0, $315dbc24fdcb29cb$export$e4a566eeb613cc47));
        if (Math.random() < 0.2) return `{{\\left({${randomOption1(a)}}\\right)}{\\left({${randomOption2(b)}}\\right)}}`;
        return `{ \\left({${randomOption1(a)} - ${randomOption2(c)}}\\right) \\left({${randomOption3(b)} + ${moreRandomOptions(c)}}\\right) + {${moreRandomOptions(c)}}{\\left({${moreRandomOptions(b)} - ${moreRandomOptions(a)} + ${moreRandomOptions(c)}} \\right)} }`;
    }
    // Strategy 2: Consecutive squares - n = (d + 1)^2 - d^2 = 2d + 1
    if (n > 2 && (0, $1dbc6a46e06e42e9$export$d36793d8f5c37d4d)(n) && randomValue < 0.40) {
        const d = Math.floor(n / 2);
        if (Math.random() < 0.5) return `{${randomOption1(2)} \\left({${randomOption2(d)}}\\right) + ${randomOption3(1)}}`;
        return `{\\left({${randomOption1(d)} + ${randomOption2(1)}}\\right)^2 - \\left({${randomOption3(d)}}\\right)^2}`;
    }
    // Strategy 3: Square root for small numbers
    if (randomValue < 0.55 && n < (0, $315dbc24fdcb29cb$export$32b910926cdc0d75)) {
        const square = n ** 2;
        return `{\\sqrt{${randomOption1(square)}}}`;
    }
    // Strategy 4: Sum of odd numbers = n^2
    if (n > 1 && (0, $1dbc6a46e06e42e9$export$18e26528b2f5558d)(n) && randomValue < 0.6) {
        const squareroot = Math.sqrt(n);
        if (Math.random() < 0.2) {
            let sum = `${randomOption1(1)}`;
            let oddVal = 1;
            for(let i = 0; i < squareroot - 1; i++){
                oddVal += 2;
                sum += `+ ${moreRandomOptions(oddVal)}`;
            }
            return `{ ${sum} }`;
        }
        // (a + b)^2 expansion
        const a = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(1, squareroot - 1);
        const b = squareroot - a;
        if (Math.random() < 0.5) return `{ {\\left(${randomOption1(a)} + ${randomOption2(b)}\\right)}^2}`;
        return `{ {\\left(${randomOption1(a)}\\right)}^2 + {${moreRandomOptions(2)}}{\\left(${randomOption2(a)}\\right)}{\\left(${randomOption3(b)}\\right)} + {\\left(${moreRandomOptions(b)}\\right)}^2}`;
    }
    // Strategy 5: Difference of consecutive squares
    if ((0, $1dbc6a46e06e42e9$export$d36793d8f5c37d4d)(n) && randomValue < 0.7) {
        const a = Math.floor(n / 2);
        const b = n - a;
        if (n < 22) return `{${randomOption1(b ** 2)} - ${randomOption2(a ** 2)}}`;
        return `{ \\left({${randomOption1(b)}}\\right)^2 -  \\left({${randomOption2(a)}}\\right)^2}`;
    }
    // Strategy 6: Pythagorean triples using Fibonacci's method
    if (randomValue < 0.8 && (0, $1dbc6a46e06e42e9$export$d36793d8f5c37d4d)(n) && n < (0, $315dbc24fdcb29cb$export$32b910926cdc0d75)) {
        const a = n;
        const aSquare = a ** 2;
        const position = (aSquare + 1) / 2;
        let bSquare = 0;
        let odd = -1;
        for(let i = 1; i < position; i++){
            odd += 2;
            bSquare += odd;
        }
        const b = Math.sqrt(bSquare);
        const cSquare = odd + 2 + bSquare;
        const c = Math.sqrt(cSquare);
        return `{\\sqrt{\\left({${randomOption1(c)}}\\right)^2 - \\left({${randomOption2(b)}}\\right)^2}}`;
    }
    // Strategy 7: Multiplication and addition
    if (randomValue < 0.90) {
        const randNum = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(1, n + 1);
        const r = n % randNum;
        const a = Math.floor(n / randNum);
        return `${randomOption1(a)} \\times {${randomOption2(randNum)}} + ${randomOption3(r)}`;
    }
    // Strategy 8: Multiply and divide
    const r = (0, $1dbc6a46e06e42e9$export$3c5f89dae98e900b)(1, 5);
    return `${randomOption1(n * r)} \\over {${randomOption2(r)}}`;
}



function $395fcb52fc2fe46c$export$f1f9ebb6bd38268c(number, config) {
    // Build list of available generator functions based on config
    const possibleOptions = [];
    if (config.eulersIdentity) possibleOptions.push((n)=>(0, $32d147077145fdbe$export$4f7fcae0ef12d1a7)(n, config.gammaFunction));
    if (config.limitExponential) {
        possibleOptions.push((0, $32d147077145fdbe$export$1923b1715a1d3b35));
        possibleOptions.push((0, $32d147077145fdbe$export$63b8956c35915643));
    }
    if (config.limitPolynomial) {
        possibleOptions.push((n)=>(0, $32d147077145fdbe$export$b79f25742e3e8973)(n, config.gammaFunction));
        possibleOptions.push((n)=>(0, $32d147077145fdbe$export$55706094e203377f)(n, config.gammaFunction));
    }
    if (config.geometricSeries) possibleOptions.push((n)=>(0, $32d147077145fdbe$export$ee3ee67983452ed6)(n, config.gammaFunction));
    // Special handling for trig identity - needs to wrap other generators
    if (config.trig) {
        const originalOptions = [
            ...possibleOptions
        ];
        // Create trig-wrapped generator
        const trigGenerator = (n)=>{
            // Filter out some options for trig wrapping
            const optionsForTrig = originalOptions.filter((opt)=>opt !== (0, $32d147077145fdbe$export$1923b1715a1d3b35) && opt !== trigGenerator);
            let randOption;
            if (optionsForTrig.length > 0) randOption = (num)=>(0, $1dbc6a46e06e42e9$export$94951fac5549ef77)(optionsForTrig)(num);
            else randOption = sameNumber;
            return (0, $32d147077145fdbe$export$9a51c259a21d4029)(n, randOption);
        };
        possibleOptions.push(trigGenerator);
    }
    // Fallback function if all options are disabled
    const sameNumber = (n)=>n;
    // Generate the expression
    return (0, $4a118e3e819b7e0c$export$4e06b4a690896b27)(number, possibleOptions, sameNumber);
}
function $395fcb52fc2fe46c$export$4d09d4ac8ba225dd(value) {
    const number = Number(value);
    if (isNaN(number)) return {
        valid: false,
        error: 'Please enter a valid number'
    };
    if (value === '' || value === null || value === undefined) return {
        valid: false,
        error: 'Please enter a number'
    };
    if (number < 0 || number > 1000) return {
        valid: false,
        error: 'Number must be between 0 and 1000'
    };
    if (!Number.isInteger(number)) return {
        valid: false,
        error: 'Please enter an integer'
    };
    return {
        valid: true
    };
}


/**
 * URL Sharing utilities - encode/decode application state for sharing
 */ /**
 * Encodes the current state (number and config) into a URL-safe string
 * @param {number} number - The input number
 * @param {Object} config - The checkbox configuration
 * @returns {string} Base64-encoded state
 */ function $d905fa48ba9bea45$export$ba5ae29bdb29802d(number, config) {
    const state = {
        n: number,
        g: config.gammaFunction,
        e: config.eulersIdentity,
        le: config.limitExponential,
        lp: config.limitPolynomial,
        t: config.trig,
        gs: config.geometricSeries
    };
    const json = JSON.stringify(state);
    // Convert to base64 and make URL-safe
    return btoa(json).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); // Remove padding
}
function $d905fa48ba9bea45$export$f011bbd5d4754f0f(encoded) {
    try {
        // Restore base64 format
        let base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
        // Add padding if needed
        while(base64.length % 4)base64 += '=';
        const json = atob(base64);
        const state = JSON.parse(json);
        // Expand to full config object
        return {
            number: state.n,
            config: {
                gammaFunction: state.g ?? true,
                eulersIdentity: state.e ?? true,
                limitExponential: state.le ?? true,
                limitPolynomial: state.lp ?? true,
                trig: state.t ?? true,
                geometricSeries: state.gs ?? true
            }
        };
    } catch (error) {
        console.error('Failed to decode state:', error);
        return null;
    }
}
function $d905fa48ba9bea45$export$7072d9f91d112494() {
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get('s');
    if (!encoded) return null;
    return $d905fa48ba9bea45$export$f011bbd5d4754f0f(encoded);
}
function $d905fa48ba9bea45$export$172c793d6657bd62(number, config) {
    const encoded = $d905fa48ba9bea45$export$ba5ae29bdb29802d(number, config);
    const url = new URL(window.location.href);
    url.search = `?s=${encoded}`;
    return url.toString();
}
function $d905fa48ba9bea45$export$c53d3fa896bb7eef(number, config) {
    const encoded = $d905fa48ba9bea45$export$ba5ae29bdb29802d(number, config);
    const url = new URL(window.location.href);
    url.search = `?s=${encoded}`;
    window.history.replaceState({}, '', url);
}


document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('form');
    const displayCheckbox = document.getElementById('display');
    const closeButton = document.querySelector('.close');
    const inputField = document.getElementById('input');
    const outputDiv = document.getElementById('output');
    const renderButton = document.getElementById('render');
    const downloadBtn = document.getElementById('download-img');
    const shareBtn = document.getElementById('share-btn');
    form.addEventListener('submit', handleFormSubmit);
    displayCheckbox.addEventListener('change', convert);
    closeButton.addEventListener('click', ()=>{
        document.getElementById('mobile-notice').style.display = 'none';
    });
    shareBtn.addEventListener('click', handleShare);
    loadStateFromURL();
    function loadStateFromURL() {
        const state = (0, $d905fa48ba9bea45$export$7072d9f91d112494)();
        if (state) {
            inputField.value = state.number;
            document.getElementById('gamma-function').checked = state.config.gammaFunction;
            document.getElementById('eulers-identity').checked = state.config.eulersIdentity;
            document.getElementById('limits-exponential').checked = state.config.limitExponential;
            document.getElementById('limits-polynomial').checked = state.config.limitPolynomial;
            document.getElementById('trig').checked = state.config.trig;
            document.getElementById('geometric-series').checked = state.config.geometricSeries;
            if (window.MathJax && window.MathJax.startup) MathJax.startup.promise.then(()=>{
                convert();
            });
            else window.addEventListener('load', ()=>{
                if (window.MathJax && window.MathJax.startup) MathJax.startup.promise.then(()=>{
                    convert();
                });
            });
        }
    }
    function handleFormSubmit(event) {
        event.preventDefault();
        convert();
    }
    function convert() {
        const number = inputField.value;
        const validation = (0, $395fcb52fc2fe46c$export$4d09d4ac8ba225dd)(number);
        if (!validation.valid) {
            showError(validation.error);
            return;
        }
        const config = {
            gammaFunction: document.getElementById('gamma-function').checked,
            eulersIdentity: document.getElementById('eulers-identity').checked,
            limitExponential: document.getElementById('limits-exponential').checked,
            limitPolynomial: document.getElementById('limits-polynomial').checked,
            trig: document.getElementById('trig').checked,
            geometricSeries: document.getElementById('geometric-series').checked
        };
        const input = (0, $395fcb52fc2fe46c$export$f1f9ebb6bd38268c)(Number(number), config);
        renderEquation(input);
        (0, $d905fa48ba9bea45$export$c53d3fa896bb7eef)(Number(number), config);
    }
    function handleShare() {
        const number = inputField.value;
        const validation = (0, $395fcb52fc2fe46c$export$4d09d4ac8ba225dd)(number);
        if (!validation.valid) {
            showError('Please generate an equation first before sharing!');
            return;
        }
        const config = {
            gammaFunction: document.getElementById('gamma-function').checked,
            eulersIdentity: document.getElementById('eulers-identity').checked,
            limitExponential: document.getElementById('limits-exponential').checked,
            limitPolynomial: document.getElementById('limits-polynomial').checked,
            trig: document.getElementById('trig').checked,
            geometricSeries: document.getElementById('geometric-series').checked
        };
        const shareableURL = (0, $d905fa48ba9bea45$export$172c793d6657bd62)(Number(number), config);
        // Try to use native share API if available (mobile devices)
        if (navigator.share) navigator.share({
            title: `num2math - Equation for ${number}`,
            text: `Check out this complicated math equation that equals ${number}!`,
            url: shareableURL
        }).catch((error)=>{
            if (error.name !== 'AbortError') copyToClipboard(shareableURL);
        });
        else copyToClipboard(shareableURL);
    }
    function copyToClipboard(text) {
        navigator.clipboard.writeText(text).then(()=>{
            const originalText = shareBtn.textContent;
            shareBtn.textContent = "\u2713 Link copied!";
            shareBtn.style.backgroundColor = '#28a745';
            setTimeout(()=>{
                shareBtn.textContent = originalText;
                shareBtn.style.backgroundColor = '';
            }, 2000);
        }).catch(()=>{
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            const originalText = shareBtn.textContent;
            shareBtn.textContent = "\u2713 Link copied!";
            setTimeout(()=>{
                shareBtn.textContent = originalText;
            }, 2000);
        });
    }
    function showError(message) {
        outputDiv.innerHTML = `<p style="color: red; padding: 10px;">${message}</p>`;
    }
    function renderEquation(latexExpression) {
        renderButton.disabled = displayCheckbox.disabled = true;
        outputDiv.innerHTML = '';
        MathJax.texReset();
        const options = MathJax.getMetricsFor(outputDiv);
        options.display = displayCheckbox.checked;
        MathJax.tex2svgPromise(latexExpression, options).then((node)=>{
            outputDiv.appendChild(node);
            MathJax.startup.document.clear();
            MathJax.startup.document.updateDocument();
            downloadBtn.style.display = 'block';
            shareBtn.style.display = 'inline-block';
        }).catch((err)=>{
            const pre = document.createElement('pre');
            pre.textContent = err.message;
            outputDiv.appendChild(pre);
        }).finally(()=>{
            renderButton.disabled = displayCheckbox.disabled = false;
        });
    }
});


//# sourceMappingURL=num2math.7065e647.js.map
